import React, { useEffect } from "react";
import IconBeneficiario from "../../Resources/svg/Icons/IconBeneficiario";
import { validateTextOnlyAlphanumeric, validatorField } from "../../Utils/validators";
import ErrorCustom from "../../Components/errorCustom";
import { useFormContext } from "react-hook-form";

interface Props {
  disableRemove: boolean;
  parentsPepData: Array<any>;
  parentPep: Object;
  index: number;
  removeParentPep: Function;
  count: number;
}

export const ParentPepForm = ({
  disableRemove,
  parentsPepData,
  parentPep,
  index,
  removeParentPep,
  count,
}: Props) => {
  const methods = useFormContext();
  const { register, errors, watch, setValue } = methods;

  const typeDocumentControl = parentsPepData
    .flatMap((item) => item.childControls)
    .find((child) => child.metadata.placeholder === "Tipo documento");

  const nroDocumentControl = parentsPepData
    .flatMap((item) => item.childControls)
    .find((child) => child.metadata.placeholder === "Nro. documento");

  const nameControl = parentsPepData
    .flatMap((item) => item.childControls)
    .find((child) => child.metadata.placeholder === "Nombres");
  
  const lastNameControl = parentsPepData
    .flatMap((item) => item.childControls)
    .find((child) => child.metadata.placeholder === "Apellidos");

  const chargeControl = parentsPepData
    .flatMap((item) => item.childControls)
    .find((child) => child.metadata.placeholder === "Cargo");

  const institutionControl = parentsPepData
    .flatMap((item) => item.childControls)
    .find((child) => child.metadata.placeholder === "Institución");


  const typeDocumentSk = Object.keys(parentPep)[0];
  const nroDocumentoSk = Object.keys(parentPep)[1];
  const nameSk = Object.keys(parentPep)[2];
  const lastNameSk = Object.keys(parentPep)[3];
  const chargeSk = Object.keys(parentPep)[4];
  const institutionSk = Object.keys(parentPep)[5];

  const remove = (e: any) => {
    e.preventDefault();
    if(disableRemove) return;
    removeParentPep(index);
  };

  useEffect(() => {
    console.log("parentsPepData", parentsPepData);
  }, [parentsPepData]);  

  return (
    <>
      <div
        className={`beneficiaryForm${index === 0 ? " first" : ""}`}
        style={{ position: "relative" }}
      >
        <div className="clientForm__beneficiary-box">
          <div className="clientForm__beneficiary-box-icon">
            <IconBeneficiario />
            <div className="clientForm__beneficiary">
              Pariente Pep {(index+1) + 1}
            </div>
          </div>
          {count > 0 && (
            <p
              className={`clientForm__eliminar ${disableRemove ? "disabled-action" : ""}`}
              onClick={(e) => {
                remove(e);
              }}
            >
              Eliminar
            </p>
          )}
        </div>
      </div>

      {parentsPepData[0] && (
        <div className="question__control input-field">
          <div className="group-form">
            <div className="question__control input-field">
              <select 
                name={typeDocumentSk} 
                id={typeDocumentSk}
                ref={register({ validate: validatorField })}
              >
                <option value={""} disabled selected>
                  {typeDocumentControl.metadata.placeholder}
                </option>
                {typeDocumentControl.metadata.options.map((option: any, idx: number) => (
                  <option value={option} key={idx}>
                    {option}
                  </option>
                ))}
              </select>
              <ErrorCustom errors={errors} name={typeDocumentSk} />
            </div>
            
            <div className="clientForm__control input-field">
              <input 
                id={nroDocumentoSk} 
                name={nroDocumentoSk} 
                type="text" 
                autoComplete="off"
                maxLength={nroDocumentControl.metadata.maxLength}
                ref={register({ validate: validatorField })}
              />
              <label htmlFor={nroDocumentoSk}>{nroDocumentControl.metadata.placeholder}</label>
              <ErrorCustom errors={errors} name={nroDocumentoSk} />
            </div>
          </div>
        </div>
      )}

      {parentsPepData[1] && (
        <div className="question__control input-field">
          <div className="group-form">
            <div className="clientForm__control input-field">
              <input
                id={nameSk}
                name={nameSk}
                type="text"
                autoComplete="off"
                maxLength={nameControl.metadata.maxLength}
                ref={register({
                  validate: {
                    validatorField,
                  },
                })}
              />
              <label
                htmlFor={nameSk}
              >
                {nameControl.metadata.placeholder}
              </label>
              <ErrorCustom errors={errors} name={nameSk} />
            </div>

            <div className="clientForm__control input-field">
              <input
                id={lastNameSk}
                name={lastNameSk}
                type="text"
                autoComplete="off"
                maxLength={lastNameControl.metadata.maxLength}
                ref={register({
                  validate: {
                    validatorField,
                  },
                })}
              />
              <label
                htmlFor={lastNameSk}
              >
                {lastNameControl.metadata.placeholder}
              </label>
              <ErrorCustom errors={errors} name={lastNameSk} />
            </div>
          </div>
        </div>
      )}

      {parentsPepData[2] && (
        <div className="question__control input-field">
          <div className="group-form">
            <div className="clientForm__control input-field">
              <input
                id={chargeSk}
                name={chargeSk}
                type="text"
                autoComplete="off"
                maxLength={chargeControl.metadata.maxLength}
                ref={register({
                  validate: {
                    validatorField,
                  },
                })}
              />
              <label
                htmlFor={chargeSk}
              >
                {chargeControl.metadata.placeholder}
              </label>
              <ErrorCustom errors={errors} name={chargeSk} />
            </div>

            <div className="clientForm__control input-field">
              <input
                id={institutionSk}
                name={institutionSk}
                type="text"
                autoComplete="off"
                maxLength={institutionControl.metadata.maxLength}
                ref={register({
                  validate: {
                    validatorField,
                  },
                })}
              />
              <label
                htmlFor={institutionSk}
              >
                {institutionControl.metadata.placeholder}
              </label>
              <ErrorCustom errors={errors} name={institutionSk} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
